// Translation data for the website
export const translations = {
  // Navigation
  nav: {
    home: { hi: 'होम', en: 'Home' },
    services: { hi: 'सेवाएं', en: 'Services' },
    about: { hi: 'हमारे बारे में', en: 'About Us' },
    contact: { hi: 'संपर्क', en: 'Contact' },
    blog: { hi: 'ब्लॉग', en: 'Blog' }
  },

  // Home page content
  home: {
    title: { 
      hi: 'आचार्य अभिषेक पांडेय', 
      en: 'Acharya Abhishek Pandey' 
    },
    subtitle: { 
      hi: 'प्रामाणिक ज्योतिष और तंत्र विशेषज्ञ', 
      en: 'Authentic Astrology & Tantra Expert' 
    },
    heroDescription: { 
      hi: 'हमारे पास 15+ वर्षों का अनुभव है। सभी प्रकार की पूजा, ज्योतिष कुंडली, तांत्रिक समाधान और रत्न उपचार की सेवा प्रदान करते हैं।', 
      en: 'With 15+ years of experience, we provide all types of Puja, Astro Kundali, Tantrik solutions, and Gemstone remedies.' 
    },
    welcomeTitle: { 
      hi: 'आपका स्वागत है', 
      en: 'Welcome' 
    },
    welcomeText: { 
      hi: 'आध्यात्मिक मार्गदर्शन और जीवन की समस्याओं के लिए प्रामाणिक समाधान पाएं। हमारी विशेषज्ञता में वैदिक ज्योतिष, तंत्र-मंत्र, और रत्न चिकित्सा शामिल है।', 
      en: 'Get authentic solutions for spiritual guidance and life problems. Our expertise includes Vedic Astrology, Tantra-Mantra, and Gemstone therapy.' 
    },
    servicesTitle: { 
      hi: 'हमारी सेवाएं', 
      en: 'Our Services' 
    },
    whyChooseTitle: { 
      hi: 'हमें क्यों चुनें', 
      en: 'Why Choose Us' 
    },
    experience: { 
      hi: '15+ वर्षों का अनुभव', 
      en: '15+ Years Experience' 
    },
    authentic: { 
      hi: 'प्रामाणिक विधि', 
      en: 'Authentic Methods' 
    },
    trusted: { 
      hi: 'हजारों संतुष्ट ग्राहक', 
      en: 'Thousands of Satisfied Clients' 
    },
    available: { 
      hi: '24/7 उपलब्ध', 
      en: '24/7 Available' 
    }
  },

  // Services content
  services: {
    title: { hi: 'हमारी सेवाएं', en: 'Our Services' },
    pujaTitle: { hi: 'सभी प्रकार की पूजा', en: 'All Types of Puja' },
    astroTitle: { hi: 'ज्योतिष सेवाएं', en: 'Astrology Services' },
    tantrikTitle: { hi: 'तांत्रिक समाधान', en: 'Tantrik Solutions' },
    gemstoneTitle: { hi: 'रत्न एवं उपचार', en: 'Gemstones & Remedies' },
    
    // Puja services
    pujas: {
      ganeshPuja: { hi: 'गणेश पूजा', en: 'Ganesh Puja' },
      durga: { hi: 'दुर्गा पूजा', en: 'Durga Puja' },
      laxmi: { hi: 'लक्ष्मी पूजा', en: 'Lakshmi Puja' },
      saraswati: { hi: 'सरस्वती पूजा', en: 'Saraswati Puja' },
      shiva: { hi: 'शिव पूजा', en: 'Shiva Puja' },
      hanuman: { hi: 'हनुमान पूजा', en: 'Hanuman Puja' },
      kali: { hi: 'काली पूजा', en: 'Kali Puja' },
      vishnu: { hi: 'विष्णु पूजा', en: 'Vishnu Puja' },
      navgraha: { hi: 'नवग्रह पूजा', en: 'Navgraha Puja' },
      grihapravesha: { hi: 'गृह प्रवेश पूजा', en: 'Griha Pravesh Puja' },
      satyanarayan: { hi: 'सत्यनारायण पूजा', en: 'Satyanarayan Puja' },
      rudrabhishek: { hi: 'रुद्राभिषेक', en: 'Rudrabhishek' },
      vastuPujan: { hi: 'वस्तु पूजन', en: 'Vastu Pujan' },
      vastuShanti: { hi: 'वस्तु शांति पूजा', en: 'Vastu Shanti Puja' },
      bhagavatKatha: { hi: 'श्री मद भागवत कथा', en: 'Shri Mad Bhagavat Katha' },
      bhagavatParayan: { hi: 'भागवत परायण', en: 'Bhagavat Parayan' },
      mulShanti: { hi: 'मूल शांति पूजन', en: 'Mul Shanti Pujan' },
      mahamrityunjay: { hi: 'महामृत्युंजय जप', en: 'Mahamrityunjay Jap' },
      kalSarpShanti: { hi: 'काल सर्प शांति', en: 'Kal Sarp Shanti' },
      grahShanti: { hi: 'ग्रह शांति पूजन', en: 'Graha Shanti Pujan' },
      pitraDoshShanti: { hi: 'पितृ दोष शांति पूजन', en: 'Pitra Dosh Shanti Pujan' },
      vivahRukawat: { hi: 'विवाह में रुकावट', en: 'Marriage Obstacles' },
      sammohanKriya: { hi: 'सम्मोहन क्रिया', en: 'Sammohan Kriya' },
      allPujan: { hi: 'हर प्रकार का पूजन इत्यादि', en: 'All Types of Pujan etc.' }
    },

    // Astrology services
    astrology: {
      kundaliAnalysis: { hi: 'कुंडली विश्लेषण', en: 'Kundali Analysis' },
      kundaliBanwana: { hi: 'कुंडली बनवाना', en: 'Kundali Making' },
      ganitJyoti: { hi: 'गणित ज्योति', en: 'Ganit Jyoti' },
      matching: { hi: 'गुण मिलान', en: 'Horoscope Matching' },
      career: { hi: 'करियर गाइडेंस', en: 'Career Guidance' },
      marriage: { hi: 'विवाह संबंधी सलाह', en: 'Marriage Consultation' },
      health: { hi: 'स्वास्थ्य ज्योतिष', en: 'Health Astrology' },
      business: { hi: 'व्यापार ज्योतिष', en: 'Business Astrology' },
      remedies: { hi: 'ज्योतिषीय उपचार', en: 'Astrological Remedies' },
      yearly: { hi: 'वार्षिक भविष्यफल', en: 'Yearly Predictions' },
      allKundali: { hi: 'इत्यादि', en: 'And More' }
    },

    // Tantrik solutions
    tantrik: {
      blackMagic: { hi: 'जादू टोना से छुटकारा', en: 'Black Magic Removal' },
      negative: { hi: 'नकारात्मक ऊर्जा हटाना', en: 'Negative Energy Removal' },
      protection: { hi: 'सुरक्षा कवच', en: 'Protection Shield' },
      vashikaran: { hi: 'वशीकरण', en: 'Vashikaran' },
      mohini: { hi: 'मोहिनी विद्या', en: 'Mohini Vidya' },
      attraction: { hi: 'आकर्षण मंत्र', en: 'Attraction Mantras' },
      evil: { hi: 'बुरी नजर हटाना', en: 'Evil Eye Removal' },
      ghost: { hi: 'भूत प्रेत निवारण', en: 'Ghost Spirit Removal' }
    },

    // Gemstones
    gemstones: {
      emerald: { hi: 'पन्ना', en: 'Emerald (Panna)' },
      topaz: { hi: 'पोखराज', en: 'Yellow Sapphire (Pokhraj)' },
      sapphire: { hi: 'नीलम', en: 'Blue Sapphire (Neelam)' },
      gomed: { hi: 'गोमेद', en: 'Hessonite (Gomed)' },
      catseye: { hi: 'लहसुनिया', en: 'Cat\'s Eye (Lehsunia)' },
      ruby: { hi: 'माणिक्य', en: 'Ruby (Manik)' },
      pearl: { hi: 'मोती', en: 'Pearl (Moti)' },
      coral: { hi: 'मूंगा', en: 'Red Coral (Moonga)' },
      diamond: { hi: 'हीरा', en: 'Diamond (Heera)' },
      sunela: { hi: 'सुनहला', en: 'Sunela' },
      neelam: { hi: 'नीलम', en: 'Neelam' },
      panna: { hi: 'पन्ना', en: 'Panna' },
      firoza: { hi: 'फिरोजा', en: 'Turquoise (Firoza)' },
      opal: { hi: 'ओप्पल', en: 'Opal' },
      yellowSapphire: { hi: 'पोखराज', en: 'Yellow Sapphire (Pokhraj)' },
      blueSapphire: { hi: 'नीलम', en: 'Blue Sapphire (Neelam)' },
      catEye: { hi: 'लहसुनिया', en: 'Cat\'s Eye (Lehsunia)' },
      hessonite: { hi: 'गोमेद', en: 'Hessonite (Gomed)' },
      moonstone: { hi: 'चंद्रकांत मणि', en: 'Moonstone' },
      turquoise: { hi: 'फिरोजा', en: 'Turquoise (Firoza)' },
      allCertifiedGems: { hi: 'हर प्रकार के प्रमाणित रत्न', en: 'All Types of Certified Gems' }
    }
  },

  // Contact page
  contact: {
    title: { hi: 'संपर्क करें', en: 'Contact Us' },
    getInTouch: { hi: 'संपर्क में रहें', en: 'Get In Touch' },
    description: { hi: 'किसी भी सहायता के लिए हमसे संपर्क करें। हम 24/7 उपलब्ध हैं।', en: 'Contact us for any assistance. We are available 24/7.' },
    phone: { hi: 'फोन नंबर', en: 'Phone Number' },
    email: { hi: 'ईमेल', en: 'Email' },
    address: { hi: 'पता', en: 'Address' },
    whatsapp: { hi: 'WhatsApp', en: 'WhatsApp' },
    followUs: { hi: 'हमें फॉलो करें', en: 'Follow Us' },
    quickContact: { hi: 'त्वरित संपर्क', en: 'Quick Contact' },
    callNow: { hi: 'अभी कॉल करें', en: 'Call Now' },
    response24hrs: { hi: 'हम आपके संदेश का 24 घंटे के अंदर उत्तर देते हैं।', en: 'We respond to your messages within 24 hours.' },
    emergencyCall: { hi: 'आपातकालीन स्थिति में कृपया सीधे फोन करें।', en: 'For emergencies, please call directly.' },
    
    // FAQ Section
    faq: {
      title: { hi: 'सामान्य प्रश्न', en: 'Frequently Asked Questions' },
      consultation: {
        question: { hi: 'परामर्श के लिए कितना समय लगता है?', en: 'How long does a consultation take?' },
        answer: { hi: 'सामान्यतः 30-60 मिनट, समस्या की जटिलता के आधार पर।', en: 'Generally 30-60 minutes, depending on the complexity of the problem.' }
      },
      online: {
        question: { hi: 'क्या ऑनलाइन परामर्श उपलब्ध है?', en: 'Is online consultation available?' },
        answer: { hi: 'जी हाँ, वीडियो कॉल, फोन कॉल और WhatsApp के माध्यम से।', en: 'Yes, through video call, phone call and WhatsApp.' }
      },
      fees: {
        question: { hi: 'परामर्श शुल्क क्या है?', en: 'What are the consultation fees?' },
        answer: { hi: 'सेवा के अनुसार अलग-अलग शुल्क है। विस्तार के लिए संपर्क करें।', en: 'Different fees according to service. Contact for details.' }
      },
      payment: {
        question: { hi: 'क्या पूर्व भुगतान आवश्यक है?', en: 'Is advance payment required?' },
        answer: { hi: 'नहीं, आप परामर्श के बाद भुगतान कर सकते हैं।', en: 'No, you can pay after the consultation.' }
      }
    },
    
    // Contact form
    form: {
      title: { hi: 'संदेश भेजें', en: 'Send Message' },
      name: { hi: 'नाम', en: 'Name' },
      emailLabel: { hi: 'ईमेल', en: 'Email' },
      subject: { hi: 'विषय', en: 'Subject' },
      message: { hi: 'संदेश', en: 'Message' },
      placeholder: { hi: 'यहाँ अपना संदेश लिखें...', en: 'Write your message here...' },
      send: { hi: 'भेजें', en: 'Send Message' },
      sending: { hi: 'भेजा जा रहा है...', en: 'Sending...' },
      success: { hi: 'संदेश सफलतापूर्वक भेजा गया!', en: 'Message sent successfully!' },
      error: { hi: 'संदेश भेजने में त्रुटि हुई।', en: 'Error sending message.' }
    }
  },

  // About page
  about: {
    title: { hi: 'हमारे बारे में', en: 'About Us' },
    description: { hi: 'आचार्य अभिषेक पांडेय एक प्रसिद्ध ज्योतिषी और तंत्र विशेषज्ञ हैं जिनके पास 15+ वर्षों का अनुभव है।', en: 'Acharya Abhishek Pandey is a renowned astrologer and tantra expert with 15+ years of experience.' },
    expertise: { hi: 'विशेषज्ञता', en: 'Expertise' },
    mission: { hi: 'हमारा मिशन', en: 'Our Mission' },
    vision: { hi: 'हमारा दृष्टिकोण', en: 'Our Vision' }
  },

  // Blog section
  blog: {
    title: { hi: 'ब्लॉग', en: 'Blog' },
    blogTitle: { hi: 'आध्यात्मिक ब्लॉग', en: 'Spiritual Blog' },
    subtitle: { hi: 'ज्योतिष, तंत्र-मंत्र, रत्न विज्ञान और आध्यात्म पर नवीनतम ज्ञान प्राप्त करें', en: 'Get latest knowledge on astrology, tantra-mantra, gemstone science and spirituality' },
    searchPlaceholder: { hi: 'ब्लॉग खोजें...', en: 'Search blog...' },
    featured: { hi: 'फीचर्ड', en: 'Featured' },
    featuredPosts: { hi: 'फीचर्ड पोस्ट्स', en: 'Featured Posts' },
    recentPosts: { hi: 'हाल की पोस्ट्स', en: 'Recent Posts' },
    relatedPosts: { hi: 'संबंधित पोस्ट्स', en: 'Related Posts' },
    categories: { hi: 'श्रेणियां', en: 'Categories' },
    tags: { hi: 'टैग्स', en: 'Tags' },
    author: { hi: 'लेखक', en: 'Author' },
    publishedOn: { hi: 'प्रकाशित', en: 'Published on' },
    readTime: { hi: 'पढ़ने का समय', en: 'Read time' },
    minutes: { hi: 'मिनट', en: 'minutes' },
    noPostsFound: { hi: 'कोई पोस्ट नहीं मिली', en: 'No posts found' },
    tryDifferentSearch: { hi: 'कृपया अन्य खोज शब्दों का प्रयास करें', en: 'Please try different search terms' },
    searchResultsFor: { hi: 'के लिए', en: 'results for' },
    resultsFound: { hi: 'परिणाम मिले', en: 'Found' },
    backToBlog: { hi: 'ब्लॉग पर वापस जाएं', en: 'Back to Blog' },
    sharePost: { hi: 'शेयर करें:', en: 'Share:' },
    linkCopied: { hi: 'लिंक कॉपी हो गया!', en: 'Link copied to clipboard!' },
    
    // Categories
    categoryAll: { hi: 'सभी', en: 'All' },
    categoryWorship: { hi: 'पूजा-पाठ', en: 'Worship & Rituals' },
    categoryGemstone: { hi: 'रत्न विज्ञान', en: 'Gemstone Science' },
    categoryFestivals: { hi: 'त्योहार और व्रत', en: 'Festivals & Fasts' },
    categoryMantras: { hi: 'मंत्र और स्तोत्र', en: 'Mantras & Hymns' },
    categoryAstrology: { hi: 'ज्योतिष समाधान', en: 'Astrological Solutions' },
    
    // CTA Section
    personalConsultation: { hi: 'व्यक्तिगत परामर्श चाहिए?', en: 'Need Personal Consultation?' },
    consultationCTA: { hi: 'अपनी समस्या का समाधान पाने के लिए आज ही संपर्क करें', en: 'Contact today to get solution to your problems' },
    contactNow: { hi: 'संपर्क करें', en: 'Contact Now' },
    
    // Advertisement placeholders
    adSpace: { hi: 'विज्ञापन स्थान', en: 'Advertisement Space' },
    sidebarAd: { hi: 'साइडबार विज्ञापन', en: 'Sidebar Advertisement' },
    adPlaceholder: { hi: 'यहां आपका विज्ञापन हो सकता है', en: 'Your ad could be here' },
    adsenseAd: { hi: 'यहां आपका Google AdSense विज्ञापन दिखेगा', en: 'Your Google AdSense ad will appear here' }
  },

  // Common buttons and labels
  common: {
    learnMore: { hi: 'और जानें', en: 'Learn More' },
    contactNow: { hi: 'अभी संपर्क करें', en: 'Contact Now' },
    bookConsultation: { hi: 'परामर्श बुक करें', en: 'Book Consultation' },
    readMore: { hi: 'और पढ़ें', en: 'Read More' },
    viewAll: { hi: 'सभी देखें', en: 'View All' },
    back: { hi: 'वापस', en: 'Back' },
    next: { hi: 'आगे', en: 'Next' },
    close: { hi: 'बंद करें', en: 'Close' },
    loading: { hi: 'लोड हो रहा है...', en: 'Loading...' }
  }
};

// Helper function to get translation
export const getTranslation = (key, language = 'hi') => {
  const keys = key.split('.');
  let translation = translations;
  
  for (const k of keys) {
    translation = translation[k];
    if (!translation) return key;
  }
  
  return translation[language] || translation['en'] || key;
};